<p-toast (onClose)="onToastClose($event)"></p-toast>
<p-toast key="progress-notifications"></p-toast>
<ng-progress color="#000000"></ng-progress>
<app-main-header *ngIf="(authService.isLoggedIn | async) && !hideNavbar"></app-main-header>
<!-- main app container -->

<router-outlet></router-outlet>